// extracted by mini-css-extract-plugin
module.exports = {"titledBorderBox":"TitledBorderBox_titledBorderBox__3I1Kj","titledBorderBoxTitle":"TitledBorderBox_titledBorderBoxTitle__17tC9"};